import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Product() {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>Product</Typography>
      <Typography>
        Scout builds a local knowledge graph from your files and apps, then lets you plug in AI agents
        for search, organization, OCR, and more—all on-device.
      </Typography>
    </Box>
  );
}